import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

function Navbar(){
  return(
    <div>
      <div className="cursor"></div>
      <div className="cursor2"></div>
      <div className="sidemenu-wrapper sidemenu-info">
        <div className="sidemenu-content"><button className="closeButton sideMenuCls"><i className="far fa-times"></i></button>
          <div className="widget">
            <div className="th-widget-about">
              <div className="about-logo"><a href="home-company.html"><img src="assets/img/logo.svg" alt="Kotar"/></a></div>
              <p className="about-text">Construction services offer tailored solutions to meet the unique needs and
                specifications of each project.</p>
              <div className="th-social style2"><a href="https://www.facebook.com/"><i className="fab fa-facebook-f"></i></a> <a href="https://www.twitter.com/"><i className="fab fa-twitter"></i></a> <a href="https://www.linkedin.com/"><i className="fab fa-linkedin-in"></i></a> <a href="https://www.whatsapp.com/"><i className="fab fa-whatsapp"></i></a></div>
            </div>
          </div>
          <div className="widget">
            <h3 className="widget_title">Recent Posts</h3>
            <div className="recent-post-wrap">
              <div className="recent-post">
                <div className="media-img"><a href="blog-details.html"><img src="assets/img/blog/recent-post-1-1.jpg" alt="Blog Iage"/></a></div>
                <div className="media-body">
                  <div className="recent-post-meta"><a href="blog.html"><i className="far fa-calendar"></i>24 Feb , 2024</a></div>
                  <h4 className="post-title"><a className="text-inherit" href="blog-details.html">Where Vision Meets Concrete
                      Reality</a></h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img"><a href="blog-details.html"><img src="assets/img/blog/recent-post-1-2.jpg" alt="Blog "/></a></div>
                <div className="media-body">
                  <div className="recent-post-meta"><a href="blog.html"><i className="far fa-calendar"></i>22 Feb , 2024</a></div>
                  <h4 className="post-title"><a className="text-inherit" href="blog-details.html">Raising the Bar in
                      Construction.</a></h4>
                </div>
              </div>
            </div>
          </div>
          <div className="widget">
            <h3 className="widget_title">Contact Us</h3>
            <div className="th-widget-about">
              <h4 className="footer-info-title">Address Location</h4>
              <p className="footer-info"><i className="fas fa-map-marker-alt"></i>138 MacArthur Ave, USA</p>
              <h4 className="footer-info-title">Phone Number</h4>
              <p className="footer-info"><i className="fa-sharp fa-solid fa-phone"></i><a className="text-inherit" href="tel:+19524357106">+1 952-435-7106</a></p>
              <h4 className="footer-info-title">Email Address</h4>
              <p className="footer-info"><i className="fas fa-envelope"></i><a className="text-inherit" href="mailto:info@kotar.com">info@kotar.com</a></p>
            </div>
          </div>
        </div>
      </div>
      <div className="th-menu-wrapper">
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle"><i className="fal fa-times"></i></button>
          <div className="mobile-logo"><a href="/"><img src="assets/img/logo.svg" alt="MRN"/></a></div>
          <div className="th-mobile-menu">
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/services">Services</a> </li>
              <li><a href="/training">Training</a></li>
              <li><a href="/management">Management Team</a></li>
              <HashLink smooth to="/#clients" className="nav-link">Clients</HashLink>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>
        </div>
      </div>
      <header className="th-header header-layout3">
        <div className="sticky-wrapper">
          <div className="menu-area">
            <div className="container th-container">
              <div className="row justify-content-between align-items-center">
                <div className="col-auto"> 
                  <div className="header-logo"><a href="/"><img src="/assets/logos/MRN GREEN BG.jpg" alt="MRN"/></a></div>
                </div>
                <div className="col-auto d-none d-lg-block sticky-d-none">
                  <div className="info-card-wrap">
                    <div className="info-card">
                      <div className="info-card_icon"><img src="assets/img/icon/call2.svg" alt=""/></div>
                      <div className="info-card_content">
                        <p className="info-card_text">Call Us Any Time:</p><a href="tel:+27724433009" className="info-card_link">+27 72 443 3009</a>
                      </div>
                    </div>
                    <div className="info-card">
                      <div className="info-card_icon"><img src="assets/img/icon/mail.svg" alt=""/></div>
                      <div className="info-card_content">
                        <p className="info-card_text">Email Us:</p><a href="mailto:info@mrnohsc.co.za"
                          className="info-card_link">info@mrnohsc.co.za</a>
                      </div>
                    </div>
                    <div className="info-card">
                      <div className="info-card_icon"><img src="assets/img/icon/location.svg" alt=""/></div>
                      <div className="info-card_content"><span className="info-card_label">Location Address:</span>
                        <p className="info-card_link">Sweet Thorn On Beyers Office Park <br/>61 Bosbok Rd, Randpark Ridge, Randburg</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-auto sticky-d-block">
                  <nav className="main-menu d-none d-lg-inline-block">
                    <ul>
                      <li><a href="/">Home</a></li>
                      <li><a href="/services">Services</a> </li>
                      <li><a href="/training">Training</a></li>
                      <li><a href="/management">Management Team</a></li>
                      <li><HashLink smooth to="/#clients">Clients</HashLink></li>
                      <li><a href="/contact">Contact Us</a></li>
                    </ul>
                  </nav>
                </div>
                <div className="col-auto d-lg-none"><button className="th-menu-toggle d-block d-lg-none"><i className="far fa-bars"></i></button></div>
              </div>
              <div className="main-menu-area">
                <div className="row justify-content-between align-items-center">
                  <div className="col-auto">
                    <nav className="main-menu d-none d-lg-inline-block">
                      <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/services">Services</a> </li>
                        <li><a href="/training">Training</a></li>
                        <li><a href="/management">Management Team</a></li>
                        <li><HashLink smooth to="/#clients">Clients</HashLink></li>
                        <li><a href="/contact">Contact Us</a></li>
                      </ul>
                    </nav>
                  </div>
                  <div className="col-auto d-none d-lg-block">
                    <div className="header-button">
                      <a href="/contact" className="th-btn style6 th-style th-icon">Call Back<i className="fa-regular fa-arrow-right ms-2"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
    );
}

export default Navbar;
